import React from 'react';
import '../App.css';
import './services1.css';
import PopUp_Divs from './popup_divs.js'
import Purple_poly from '../images/purplepolyvid.mp4'; 
import { TbTargetArrow } from "react-icons/tb";
import { FaUserGroup } from "react-icons/fa6";
import { FaMouse } from "react-icons/fa";
import Plan from '../images/planning2.gif';
import Sales from '../images/sales-pipeline2.gif';
import Business from '../images/business2.gif';
import Seo from '../images/seo2.gif';
import Website from '../images/webpage-list2.gif';
import Boss from '../images/boss2.gif';
import { useScrollBehavior } from './useScrollBehavior.js'; 
import Footer from './footer.js' 


const Services1 = () => {
    
	useScrollBehavior();
	

	
const ROUTES = {
  "Learn More": "/about",
  "Contact Us": "/contact2",
  "See Plans": "/about",
  "Get Support": "/contact2",
  "View Case Studies": "/portfolio",
  "Get a Free Quote": "/contact2",
};

React.useEffect(() => {
  const handler = (e) => {
    
    const el = e.target.closest('button, a, [role="button"], .btn, .button, .my-button-class, [data-button]');
    if (!el) return;

    //const label = (el.textContent || "").trim();
    //const path = ROUTES[label];

	const label = (el.textContent || "").replace(/\s+/g, ' ').trim();
    const path =
    ROUTES[label] ||
    el.getAttribute('data-route') ||
    el.getAttribute('href'); 

    if (!path) return;           
	 sessionStorage.removeItem('scrollPosition');
   
    window.scrollTo(0, 0);

    e.preventDefault();          
    window.location.assign(path); 
  };
  
  document.addEventListener('click', handler, true);
  return () => document.removeEventListener('click', handler, true);
}, []);

	
	return (
		<div id='services_div1'>
			<div className='module_service' id='service_moduleOne'>
				<video  autoPlay muted loop playsInline preload="auto" crossorigin="anonymous" fetchpriority="high">
					<source src={Purple_poly} type="video/mp4" fetchpriority="high"/>
						Your browser does not support the video tag.
				</video>
				<div id='services_heading1'><h1>Web Design & Development</h1></div>
			</div>
            <div className='module_service' id='service_moduleTwo'>
				<div id='service_mod2_container'>
					<div id='service_mod2_inner1'>
						<h1 id='service_about_h1'>Your Business Deserves More Than Just a Website</h1>
						<h2>Stand Out Online. Get Started Today.</h2>
					</div>
					<div id='service_mod2_inner2'>
						<p>A poor user experience drives visitors away in fact, most won't return if 
							a website is slow, confusing, or unpolished. That's why your site must be 
							designed to be visually engaging, fast, reliable, and accessible across 
							all browsers and devices. The online space is more competitive than ever, 
							and businesses that invest in high-quality, search-optimized websites 
							have a clear advantage. Without proper design and optimization, even the 
							best companies risk going unseen. We help businesses of all sizes from l
							ocal startups to national brands — with professional website design, 
							online marketing, and everything in between. Whether it's a simple 
							service site or a large-scale ecommerce platform, our focus is on 
							delivering a tailored solution and ensuring every project meets the 
							highest standard of client satisfaction.</p>
					</div>
				</div>

			</div>
             <div className='module_service' id='service_moduleTwo'>
                <PopUp_Divs
				pageKey="services1"
                data={[
                    { 
						buttons: ["Learn More", "Contact Us"], 
                        h2: "Harmony of Innovation, Clarity, and Impact", 
                        p: "We're dedicated to building bold digital experiences that carve out a clear path, directing your audience straight toward engagement. Every detail is tailored to you compelling storytelling, polished design, and powerful tools like custom dashboards or secure client portals. From start to finish, you'll stay at the center of the process, ensuring our work moves in lockstep with your business objectives." 
                    },
                    { 
						buttons: ["See Plans", "Get Support"],
                        h2: "Always Here for Continued Growth", 
                        p: "A great website is never truly finished, it should evolve as your business does. That's why we build with flexibility in mind, giving you the ability to update your own content with ease (and we'll provide free training so you feel confident doing it). But you don't have to manage it all on your own. Our team is here as your ongoing partner, making sure your site continues to deliver results and offering guidance whenever you're ready to explore new marketing opportunities." 
                    },
                    { 
						buttons: ["View Case Studies"],
                        h2: "Strategy & Insight with Purpose", 
                        p: "Building a standout website takes more than just good design. Before writing a single line of code, we dive into research analyzing your competitors, identifying your audience, and setting clear objectives. This foundation ensures we create a site that speaks directly to your customers and positions you as the obvious choice in your market." 
                    }
                  ]}
                />
             </div>
			 <div className='module_service' id='service_moduleThree'>
				<div id='service_mod2_container2'>
					<div className="conversion-module">
						<div id='conversion-module_subdiv'>
				  			<h2>Conversion-Focused Design</h2>

  						<p>
    						We design every page to guide visitors from first impression to action.
    						That means clear messages, prominent calls-to-action, and layouts that
    						remove friction—so more people request quotes, book appointments, or buy.
  						</p>
						</div>

  				<div className="conversion-funnel">
    				<div className="step"><TbTargetArrow className="icon"/><strong>Attract:</strong> Targeted traffic lands on pages built for intent.</div>
    				<div className="step"><FaUserGroup className="icon"/><strong>Engage:</strong> Benefit-driven copy, proof (reviews/badges), and scannable sections.</div>
    				<div className="step"><FaMouse className="icon"/><strong>Convert:</strong> Sticky CTAs and short forms placed where decisions happen.</div>
  				</div>

  				<ul className="conversion-points">
    				<li>Above-the-fold CTAs on key sections</li>
    				<li>Short, high-completion forms</li>
    				<li>Trust signals: reviews, guarantees, certifications</li>
    				<li>Speed and mobile UX tuned for action</li>
  				</ul>

  				<div className="conversion-ctas">
    				<div href="/contact2" id='btn-primary' className="btn">Get a Free Quote</div>
    				<div href="/portfolio" id='btn_service' className="btn">View Case Studies</div>
  				</div>
				</div>
				</div>
			 </div>
			<div className='module_service' id='service_moduleFour'>
				<div id='mod4_div2_service'>
					<div id='mod4_div2_service_heading'>
				  		<h1>Why Choose Yokai Software Design for Your </h1>
						<h1>Next Website Design?</h1>
					</div>
					<div id='mod4_sub_div_container_service'>
						<div className='mod4_sub_div_service'>		
				  				<div id='mod4_Sub_div_icon1_service'>
									<img src={Plan} alt="plan icon" className="plan" />
								</div>
								<h2>Custom Solutions, Not Templates</h2>
								<p>Every project is built around your brand and goals — no cookie-cutter designs.</p>
						</div>
						<div className='mod4_sub_div_service'>
				  				<div id='mod4_Sub_div_icon2_service'>
				  					<img src={Sales} alt="Sales icon" className="sales" />
								</div>		
								<h2>Conversion-Focused Design</h2>
								<p>We structure every page to guide visitors toward action, from clear CTAs to streamlined forms.</p>
						</div>
						<div className='mod4_sub_div_service'>
							<div id='mod4_Sub_div_icon3_service'>
								<img src={Business} alt="Business icon" className="business" />
							</div>
							<h2>Built for Growth</h2>
							<p>Scalable websites that adapt as your business expands — add features without starting over.</p>
						</div>
						<div className='mod4_sub_div_service'>
							<div id='mod4_Sub_div_icon4_service'>
								<img src={Seo} alt="Seo icon" className="seo" />
							</div>
							<h2>SEO-Friendly From Day One</h2>
							<p>Clean code, fast load times, and search-ready structure ensure your site gets found.</p>
						</div>
						<div className='mod4_sub_div_service'>
							<div id='mod4_Sub_div_icon5_service'>
								<img src={Website} alt="Website icon" className="website_list" />
							</div>
							<h2>Transparent Process</h2>
							<p>We keep you involved at every stage with clear updates, so there are no surprises.</p>
						</div>
						<div className='mod4_sub_div_service'>
							<div id='mod4_Sub_div_icon6_service'>
								<img src={Boss} alt="Boss icon" className="boss" />
							</div>
							<h2>Ongoing Partnership</h2>
							<p>We don't disappear after launch — updates, support, and guidance are always available.</p>
						</div>
					</div>

				</div>				
			</div>
			<Footer/>
			
		</div>
	);
};

export default Services1;